
import { Vue, Component, Prop } from "vue-property-decorator";
import { TemplatePreviewableItem } from "@/types/templates";
import { configStore } from "@/store/store";

@Component
export default class PreviewChooserNothingToPreview extends Vue {
  @Prop()
  previewItem?: TemplatePreviewableItem;

  @Prop()
  nothingToPreview!: boolean;

  get builderMode() {
    return configStore.builderMode;
  }

  get previewLabel() {
    return (
      this.previewItem?.label || `ID ${this.previewItem?.id || "(no title)"}`
    );
  }
}
